<script lang="ts" setup>
import debounce from 'lodash.debounce'

const { t } = useI18n()
const localePath = useLocalePath();

const searchQuery = ref("")
const issues = ref([])
const isLoading = ref(false)

const fetchIssues = debounce(async function() {
  isLoading.value = true
  if (searchQuery.value.length > 0) {
    if (Number.isInteger(Number(searchQuery.value))) {
      issues.value = await $fetch(`/api/issues?status_id=*&issue_id=${searchQuery.value}`)
    } else {
      issues.value = await $fetch(`/api/issues?status_id=*&subject=~${searchQuery.value}`)
    }
  }
  isLoading.value = false
}, 300)

function selectIssue(issue: any) {
  navigateTo(localePath({ name: 'issues-id', params: { id: issue.id } }))
  searchQuery.value = ""
  issues.value = []
}

function clearSearched() {
  searchQuery.value = ""
  issues.value = []
}

function selectFirstIssue() {
  selectIssue({ id: +issues.value.issues[0].id })
}
</script>

<template>
  <div>
    <div class="flex items-center">
      <UInput 
        v-model="searchQuery"
        variant="outline"
        color="gray"
        size="sm"
        :placeholder="t('horizontalMenu.search')"
        icon="i-heroicons-magnifying-glass-20-solid"
        :loading="isLoading"
        @update:model-value="fetchIssues"
        @blur="clearSearched"
        @keyup.enter="selectFirstIssue" />
      <UTooltip :text="t('horizontalMenu.searchInfo')" class="ml-1">
        <UIcon name="material-symbols:info-i-rounded" class="w-5 h-5" />
      </UTooltip>
    </div>
    <div v-if="searchQuery.length > 0" class="absolute bg-white border border-gray-300 rounded shadow-lg mt-2 max-h-60 overflow-y-auto z-50">
      <ul v-if="issues.issues && issues.issues.length">
        <li v-for="issue in issues.issues" :key="issue.id" class="p-2 hover:bg-gray-100 break-words w-80 cursor-pointer border-b border-gray-200" @mousedown.prevent @click="selectIssue(issue)">
          {{ issue.subject }}
        </li>
      </ul>
      <ul v-else class="p-2">
        <li>{{ t('horizontalMenu.searchNoResults') }}</li>
      </ul>
    </div>
  </div>
</template>